import { faCircleExclamation, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Link, Message, Wrapper } from './styles'

type Props = {
  message: React.ReactNode
  linkText?: React.ReactNode
  href?: string
  className?: string
}

export const ReasonBox = ({ message, linkText, href, className }: Props) => (
  <Wrapper className={className}>
    <FontAwesomeIcon icon={faCircleExclamation} />
    <Message>{message}</Message>
    {href && (
      <Link rel="noopener noreferrer" href={href}>
        {linkText} <FontAwesomeIcon icon={faUpRightFromSquare} />
      </Link>
    )}
  </Wrapper>
)
